/* eslint-disable */
import * as React from "react";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer, useParameter } from "../../shared";
import { BusinessUnitControl } from "./controls/BusinessUnitControl";
import { CalendarControl } from "./controls/CalendarControl";
import { CommoditiesControl } from "./controls/CommoditiesControl";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { useSlideTitle } from "./hooks/useSlideTitle";
import { useDescription } from "./hooks/useDescription";
import { SLIDE_NUMBER } from "./constants";

export default function Slide24(props: { exportMode?: boolean }) {
  const { exportMode } = props;

  const [business] = useParameter<number>("@business-units");
  const title = useSlideTitle();
  const emptySubtitle = "";
  const description = useDescription();

  useExportQuery(title, emptySubtitle);
  const { isFavouriteLoading } = useFavourite();
  useSubscription();

  return (
    <ReportContainer>
      <ReportHeader title={title} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup isLoading={isFavouriteLoading}>
          <BusinessUnitControl />
          <CommoditiesControl key={business || undefined} />
          <CalendarControl />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={SLIDE_NUMBER} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart" />
          <ReportRenderer componentId="table" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
